import { createAsyncThunk } from '@reduxjs/toolkit'
import { ambassadorManagementApi } from '@services/api/ambassadorManagementApi'

export const fetchAmbassadorList = createAsyncThunk(
  'ambassadorManagement/fetchList',
  async (params: TAmbassadorManagementAPI.Params.FetchList, { rejectWithValue }) => {
    try {
      const response = await ambassadorManagementApi.fetchList(params)
      return response.data
    } catch (error: any) {
      return rejectWithValue(error.response.data)
    }
  }
)

export const downloadExcelFile = createAsyncThunk(
  'ambassadorManagement/downloadExcelFile',
  async (params: any) => {
    const response = await ambassadorManagementApi.downloadExcelFile(params)
    return response
  }
)
